﻿import window from 'window';

import { loadModules } from './foundation/moduleInitializer';

import { zenNavHeader } from './feature/navigation/zen-nav-header';
import { zenNavMenu } from './feature/navigation/zen-nav-menu';
import { zenLoginMenu } from './feature/accounts/zen-login';
import { signInLink } from './feature/accounts/sign-in-link';
import { cookieBanner } from './feature/cta/cookie-banner';
import { cookieConsent } from './feature/page-content/cookie-consent';
import { openSubMenu } from './feature/navigation/zen-nav-open-submenu';
import { closeSubMenuMobile } from './feature/navigation/zen-nav-mobile-close-submenu';
import { zenNavLoop } from './feature/navigation/zen-nav-loop';
import { zenNavDropdown } from './feature/navigation/zen-nav-dropdown';

const app = (() => {

    const modules = [
        zenNavHeader,
        zenNavMenu,
        zenLoginMenu,
        signInLink,
        cookieBanner,
        cookieConsent,
        openSubMenu,
        closeSubMenuMobile,
        zenNavLoop,
        zenNavDropdown
    ];

    return {
        init() {
            loadModules(modules);
        }
    };
})();

window.addEventListener('DOMContentLoaded', app.init);